var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dicButton"},[_c('el-button',{directives:[{name:"has-permission",rawName:"v-has-permission",value:(_vm.permission),expression:"permission"}],attrs:{"type":"text","size":"middle","title":_vm.text},on:{"click":_vm.buttonClick}},[_c('i',{staticClass:"iconfont",class:_vm.icon})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }